mutation DeleteCollectionTypes($ids: [ID!]!) {
  deleteCollectionTypes(ids: $ids) {
    id
  }
}
